export class SetErrorAction {
  public static readonly type = '[Project/Wiki/List] SetErrorAction';
  constructor(public readonly error: Error) {}
}
